module.exports = __webpack_public_path__ + "static/konzultace.3a6054e3.jpg";